import React, { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Settings2, Brain, Globe, X, MessagesSquare } from "lucide-react";
import { cn } from "@/lib/utils";
import {
  AI_MODEL,
  SEARCH_SUPPORTED_MODELS,
} from "@/store/zustand/aiActionStore";
import AnimatedToggle from "@/components/ui/animated-toggle";

const SEARCH_UNSUPPORTED_MODELS = [
  AI_MODEL.CLAUDE_3_7_SONNET,
  AI_MODEL.CLAUDE_3_5_SONNET,
  AI_MODEL.CLAUDE_4_0_SONNET,
  AI_MODEL.CLAUDE_4_0_SONNET_MAX,
];

const FeatureToggleMenu = ({
  isChatLoading,
  useReasoning,
  setUseReasoning,
  useSearch,
  setUseSearch,
  useChatOnly,
  setUseChatOnly,
  reasoningModel,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-7 w-7 p-1 rounded-md transition-colors bg-secondary-n-950"
        >
          <Settings2
            className={cn(
              "h-4 w-4 transition-colors",
              isOpen ? "text-secondary-n-50" : "text-icons-secondary"
            )}
          />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        align="start"
        className="rounded-lg px-0 py-2 w-64"
        side="top"
      >
        <div className="flex flex-col gap-2 px-2">
          <div className="flex items-center justify-between gap-4  cursor-pointer">
            <div className="flex items-center gap-2">
              <Brain className="h-4 w-4 text-secondary-n-600" />
              <span className="text-xs">Reasoning</span>
            </div>

            <AnimatedToggle
              icon={
                <X
                  className={cn(
                    "absolute top-[3px] left-[4px] w-3 h-3 text-xs font-medium"
                  )}
                />
              }
              disabled={isChatLoading}
              isOn={useReasoning}
              onChange={() => {
                if (!isChatLoading) {
                  setUseReasoning(!useReasoning);
                }
              }}
              className="p-2"
            />
          </div>
          {!SEARCH_UNSUPPORTED_MODELS.includes(reasoningModel) && (
            <div className="flex items-center justify-between gap-4  cursor-pointer">
              <div className="flex items-center gap-2">
                <Globe className="h-4 w-4 text-secondary-n-600" />
                <span className="text-xs">Search with Gemini</span>
              </div>

              <AnimatedToggle
                icon={
                  <X
                    className={cn(
                      "absolute top-[3px] left-[4px] w-3 h-3 text-xs font-medium"
                    )}
                  />
                }
                disabled={
                  !SEARCH_SUPPORTED_MODELS.has(reasoningModel) || isChatLoading
                }
                isOn={useSearch}
                onChange={() => {
                  if (isChatLoading) {
                    return;
                  }

                  setUseSearch(!useSearch);
                }}
                className="p-2"
              />
            </div>
          )}

          <div className="flex items-center justify-between gap-4  cursor-pointer">
            <div className="flex items-center gap-2">
              <MessagesSquare className="h-4 w-4 text-secondary-n-600" />
              <span className="text-xs">Chat Only</span>
            </div>

            <AnimatedToggle
              icon={
                <X
                  className={cn(
                    "absolute top-[3px] left-[4px] w-3 h-3 text-xs font-medium"
                  )}
                />
              }
              disabled={isChatLoading}
              isOn={useChatOnly}
              onChange={() => {
                if (!isChatLoading) {
                  setUseChatOnly(!useChatOnly);
                }
              }}
              className="p-2"
            />
          </div>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default FeatureToggleMenu;
